import { css as n } from "styled-components";
const t = {
  crossIcon: ({ theme: o }) => /* @__PURE__ */ n([
    "color:",
    ";"
  ], o.componentColors.toastBanner.cross),
  dismissButton: ({ theme: o }) => /* @__PURE__ */ n([
    "position:absolute;top:0;right:0;background:none;border:none;",
    ""
  ], o.components.link.base)
};
export {
  t as default
};
